import { useCallback, useState } from "react";
import { TCategoria } from "../../../../../types/api/comercial/categorias";
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";
import DialogCriacaoEditCategorias from "./DialogCriacaoEditCategorias";

export default function Categorias() {

  const [openModal, setOpenModal] = useState<TOpenModalCategorias>(null)

  //funções manipuladoras
  const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: TCategoria | null) => {
    if (action === "close") setOpenModal(null)
    if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
    if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })
  }, [])
  //

  return (
    <>
      <SessaoConfiguracao<TCategoria>
        titulo="Categorias"
        endpoints={{
          listar: "comercial/configuracoes/pesquisar-categorias",
          deletar: "comercial/configuracoes/excluir-categoria",
        }}
        colunas={colunas}
        queryKey="pesquisar-categorias"
        onEditar={(mensagem) => {
          handleModalAction("open", mensagem.id, mensagem)
        }}
        onAdicionar={() => {
          handleModalAction("open", true, null)
        }}
        mensagemSucessoDeletar="Categoria excluida com sucesso!"
        mensagemErroDeletar="Erro ao excluir categoria!"
        mensagemSemDados="Nenhuma categoria encontrada."
        mensagemParaDeletar="Esta categoria pode possuir subcategorias e/ou produtos vinculados. Tem certeza de que deseja excluí-la?"
      />

      {
        Boolean(openModal?.open) &&
        <DialogCriacaoEditCategorias
          open={Boolean(openModal?.open)}
          handleClose={() => handleModalAction("close")}
          categoriaEdit={openModal?.defaultValue ? openModal.defaultValue : null}
        />
      }
    </>
  );
}

export type TOpenModalCategorias = {
  open: number | boolean | null;
  defaultValue: TCategoria | null;
} | null

const colunas: ConfiguracaoColunas<TCategoria>[] = [
  {
    campo: "nome",
    titulo: "Nome",
  }
];